import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import kanbanReducer from "./kanban/kanbanSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    kanban: kanbanReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
